/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { getTableContent } from "../../../components/AppointmentTables";
import Alert from "../../../components/common/new/Alert/Alert";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import CustomTable from "../../../components/common/new/Table/Table";
import Toast from "../../../components/common/Toast";
import GohonzonSubHeading from "../../../components/GohozonSubHeading/GohonzonSubHeading";
import SuccessfullyBookedModal from "../../../components/SuccessfullyBookedModal/SuccessfullyBookedModal";
import {
  // ChiefNameToPositionMapper,
  Constants,
  OS_KEYS,
} from "../../../contants";
import { APPOINTMENT_TABLES_MAP } from "../../../contants/appointment";
import {
  INITIATE_APPOINTMENT_APPLICATIONS,
  SEARCH_MEMBERS_FOR_APPLY_APPOINTMENT,
  SET_MEMBER_FOR_APPLY_APPOINTMENT,
  SET_RESET_APPOINTMENT_STATE,
  INITIATE_APPOINTMENT_APPLICATIONS_TRACKING,
} from "../../../redux/actionTypes/dashboard";
import {
  selectAppointmentApplyFormValues,
  selectBlockChiefPaginationInfo,
  selectLoader,
  selectMembersForAppointmentApply,
  selectPaginationInfo,
  selectSelectedPositionId,
} from "../../../redux/selectors/appointment";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
  selectOSNamesByUserRole,
  selectUserProfile,
  // selectUserRole,
} from "../../../redux/selectors/user";
import Appointment from "../../../services/api/appointment";
import { isInteger } from "../../../utils";
import { ROUTES } from "../../../utils/constants";
import { isEmptyObj } from "../../../utils/helper";
import { getErrorInfo } from "../../gohonzon/GohonzonSubmission/helper";
import { performOperation } from "../../member/MemberSearch/utils";
import style from "./ApplyAppointment.styles";
import Loader from "../../../components/common/Loader/Loader";
import MemberSearchForm from "./MemberSearchForm/MemberSearchForm";
import AppointmentTrackingList from "../AppointmentTracking/AppointmentTrackingList";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
import SearchIconWithPeople from "../../../assets/svg/SearchIconWithPeople";
// import { APPOINTMENT_MEMBER_SEARCH } from "../../../contants/formFields";
import useUserConfig from "../../../hooks/useUserConfig";
import ForcePushAppointmentApplication from "../../../components/AppointmentModals/ForcePushAppointmentApplication/ForcePushAppointment";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import SearchFilterForm from "./SearchFilter/SearchFilter";

const BATCH_SCREENS = [
  APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW,
  APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT,
  APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT,
  APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING,
];

const isBatchScreen = (type) => {
  return BATCH_SCREENS.includes(type);
};

const SERACH_FILTER_SCREENS = [
  APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW,
  APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT,
  APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT,
  APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION,
  APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION,
];

const SearchFilter = (type) => {
  return SERACH_FILTER_SCREENS.includes(type);
};

function ApplyAppointment({ type }) {
  const [selectedApplication, setSelectedApplication] = useState([]);
  const [showToast, setShowToast] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [successModal, setSuccesModal] = useState(false);
  const [appointedEmail, setAppointedEmail] = useState(null);
  const [appointedPosition, setAppointedPosition] = useState(null);
  const userOSNames = useSelector(selectOSNamesByUserRole);
  const memberList = useSelector(selectMembersForAppointmentApply);
  const selectedPositionId = useSelector(selectSelectedPositionId);
  const normalPaginationInfo = useSelector(selectPaginationInfo);
  const blockChiefpaginationInfo = useSelector(selectBlockChiefPaginationInfo);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const userData = useSelector(selectUserProfile);
  const {
    isHelpDesk,
    isHelpDeskAdmin,
    isChapterSi,
    isRegionSi,
    isNationalSi,
    isNationalLeader,
  } = useSelector(selectAllSIUsers);
  const [selectedOption, setSelectedOption] = useState("");
  // const { isAreaSi } = useSelector(selectAllSIUsers);
  // const userRole = useSelector(selectUserRole);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const appointmentApplyFormValues = useSelector(
    selectAppointmentApplyFormValues
  );
  const isLoading = useSelector(selectLoader);
  console.log("Loader", memberList);
  const [forcePushModal, setForcePushModal] = useState(false);
  const toast = useContext(ToastAlertContext);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasPermission = useUserConfig();
  const location = useLocation();

  const toggleForcePushModal = () => {
    setForcePushModal((prev) => !prev);
  };

  const toggleAlert = () => setOpenAlert((prev) => !prev);
  const toggleSuccessModal = () => setSuccesModal((prev) => !prev);

  const shouldHidePagination = selectedPositionId === 26;
  const paginationInfo = shouldHidePagination
    ? blockChiefpaginationInfo
    : normalPaginationInfo;

  const getSelectedChief = (formValues) =>
    !isEmptyObj(formValues)
      ? [...OS_KEYS, "blockId"].find((k) => k in formValues)
      : null;

  const getOSDepthByUserRole = (params) => {
    let result = { ...params };
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      result = Object.assign(
        result,
        disabledOSKeys.reduce((acc, key) => {
          if (userData[key]) {
            return Object.assign(acc, { [key]: userData[key] });
          }
          return acc;
        }, {})
      );
    }
    return result;
  };

  const getStatus = () => {
    switch (type) {
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW:
        return "INITIATED";
      case APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT:
        return "RECOMMENDED";
      case APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT:
        return "PARTIALLY_RECOMMENDED";
      case APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT:
        return "PARTIALLY_APPROVED";
      // case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION:
      //   // return "APPROVED";
      //   return "AAC_FIRST_APPROVED";
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION:
        return "AAC_FIRST_APPROVED";
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION:
        return "AAC_SECOND_APPROVED";
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION:
        return "READY_FOR_APPOINTMENT";
      default:
        return "";
    }
  };

  const committeeType = () => {
    switch (type) {
      // case APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION:
        return isChapterSi ? "AAC" : "ARC";
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW:
        return "ARC";
      case APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION:
      case APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION:
        return "AAC";
      default:
        return "";
    }
  };

  const votingStatusType = () => {
    switch (type) {
      // case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION:
        return "COMPLETED";
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW:
      case APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION:
        return "PENDING";
      default:
        return "";
    }
  };

  const getParams = () => {
    switch (type) {
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW:
      case APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION:
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION:
        return {
          status: getStatus(),
          committeeType: committeeType(),
          votingStatus: votingStatusType(),
        };
      case APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION:
        return {
          status: getStatus(),
          committeeType: selectedOption || committeeType(),
          votingStatus: votingStatusType(),
        };
      default:
        return {
          // organisationStructure: getOSDepthByUserRole(chiefValue),
          // positions: ChiefNameToPositionMapper[userRole],
        };
    }
  };

  const getDispatchType = () => {
    if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION)
      return INITIATE_APPOINTMENT_APPLICATIONS;
    if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING)
      return INITIATE_APPOINTMENT_APPLICATIONS_TRACKING;

    return SEARCH_MEMBERS_FOR_APPLY_APPOINTMENT;
  };

  const onSearchClick = async (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE,
    memberSearchFormValues = { searchMember: "" }
  ) => {
    const { searchMember, ...rest } = memberSearchFormValues;
    const formChiefKey = getSelectedChief(rest);
    const chiefValue = formChiefKey
      ? { [formChiefKey]: rest[formChiefKey] }
      : {};

    console.log("FORM_LOG", { formChiefKey, chiefValue, rest });

    if (formChiefKey) {
      delete rest[formChiefKey];
    }

    dispatch({
      type: getDispatchType(),
      payload: {
        // fullName: isInteger(searchMember) ? "" : searchMember,
        memberId:
          searchMember && isInteger(searchMember) ? Number(searchMember) : "",
        fullName: Number(searchMember) ? "" : searchMember ?? "",
        page: pageNumber,
        size: pageSize,
        ...getParams(),
        ...rest,
        ...getOSDepthByUserRole(chiefValue),
        ...chiefValue,
        positionId: selectedPositionId,
      },
    });
  };

  const onPaginationClick = (page) => {
    const { pageSize } = paginationInfo;
    onSearchClick(page, pageSize, appointmentApplyFormValues);
  };

  const refreshList = () => {
    onSearchClick();
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    onSearchClick(0, newPageSize, appointmentApplyFormValues);
  };

  const onMemberSelect = (selectedMember, params = "") => {
    if (!params && !selectedPositionId) {
      setShowToast({
        message: "Please Select Application For",
        severity: "error",
      });
      return;
    }

    dispatch({
      type: SET_MEMBER_FOR_APPLY_APPOINTMENT,
      payload: selectedMember,
    });
    navigate(
      `${ROUTES.APPOINTMENT_SUBMISSION.path}${params ? `/${params}` : ""}`
    );
  };

  const onSubmit = (values) => {
    setSearchPerformed(true);
    const { pageSize } = paginationInfo;
    onSearchClick(0, pageSize, values);
  };

  const applicationSelectForMarkAppointment = (application) => {
    setSelectedApplication(application);
    toggleAlert();
  };

  const onForcePushApplication = (application) => {
    setSelectedApplication(application);
    setForcePushModal(true);
  };

  const markAppointmentHandler = async () => {
    try {
      const { data } = await Appointment.markAppointment(
        selectedApplication.memberDetails.memberId,
        selectedApplication.id
      );
      setAppointedEmail(data.emailId);
      setAppointedPosition(data.positionName);
      toggleAlert();
      toggleSuccessModal();
      refreshList();
    } catch (err) {
      setShowToast(getErrorInfo(err.message));
      Sentry.captureException(err);
    }
  };

  const content = useMemo(() => {
    return getTableContent(
      type
      //   {
      //   isDistrictSi,
      //   isChapterSi,
      //   isRegionSi,
      //   isZoneSi,
      //   isAreaSi,
      // }
    );
  }, [type]);

  const getRows = () => {
    const TableComponent = content.component;
    return memberList.map((member) => {
      return (
        <TableComponent
          member={member}
          onMemberSelect={onMemberSelect}
          applicationSelectForMarkAppointment={
            applicationSelectForMarkAppointment
          }
          hasPermission={hasPermission}
          onForcePushApplication={onForcePushApplication}
        />
      );
    });
  };

  useEffect(() => {
    dispatch({
      type: SET_RESET_APPOINTMENT_STATE,
    });
    onSearchClick();
  }, [type, selectedOption]);

  useEffect(() => {
    setSearchPerformed(false);
  }, [location?.pathname]);

  const OPTIONS = [
    {
      value: "ARC",
      key: "Chapter",
    },
    {
      value: "AAC",
      key: "District",
    },
  ];

  return (
    // APPOINTMENT_APPLY
    <Box sx={style.container}>
      {!isBatchScreen(type) && <MemberSearchForm onSubmit={onSubmit} />}
      {SearchFilter(type) && <SearchFilterForm onSubmit={onSubmit} />}
      {type === APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING ? (
        <>
          <Box mt="1rem" mb="2rem">
            <GohonzonSubHeading
              userOSNames={userOSNames}
              heading={content.subHeading}
              hideAction={type}
              hideOS={
                isHelpDesk ||
                isHelpDeskAdmin ||
                isNationalSi ||
                isNationalLeader
              }
            />
          </Box>
          <AppointmentTrackingList
            onSubmit={onSubmit}
            type={type}
            onMemberSelect={onMemberSelect}
          />
        </>
      ) : null}
      <Box width="25%" paddingTop="15px">
        {isRegionSi &&
          type ===
            APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION && (
            <Dropdown
              value={selectedOption}
              options={OPTIONS}
              label="Mark appointment for"
              // onChange={handleChange}
              onChange={(selected) => {
                setSelectedOption(selected.target.value);
              }}
              // showCross
              // handleClearValue={() => setFieldValue("")}
            />
          )}
      </Box>
      {type !== APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING && (
        <Box mt="1rem" mb="2rem">
          <GohonzonSubHeading
            userOSNames={userOSNames}
            heading={content.subHeading}
            hideAction={type}
            hideOS={
              isHelpDesk || isHelpDeskAdmin || isNationalSi || isNationalLeader
            }
          />
        </Box>
      )}
      {/* {memberList?.length ? ( */}
      {!isBatchScreen(type) && !searchPerformed ? (
        <div style={style.initialContent}>
          <SearchIconWithPeople width={100} />
          <span style={style.text}>Choose your Search Filter</span>
        </div>
      ) : memberList?.length &&
        type !== APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING ? (
        <Box style={style.tableContainer}>
          <Box style={style.customTable}>
            <CustomTable
              columnCellStyle={{ textAlign: "left" }}
              scrollable
              columns={content.colums}
              rows={getRows()}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
                // textAlign: "left",
              }}
            />
          </Box>
          {!shouldHidePagination && selectedPositionId !== 26 && (
            <Box style={style.pagination}>
              <Pagination
                totalPages={paginationInfo.totalPages}
                totalResults={paginationInfo.totalElements}
                currentPage={paginationInfo.currentPage}
                pageSize={paginationInfo.pageSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </Box>
          )}
        </Box>
      ) : (
        !isLoading && (
          <div style={style.initialContent}>
            {/* know bug No Result does not pop out if we replace 
            memberList.length === 0 with memberList.length  */}
            {memberList.length === 0 ? (
              <Box style={style.emptyContainer}>
                {type !== APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING && (
                  <h1 style={style.noDataMsg}>No Results</h1>
                )}
              </Box>
            ) : (
              !isBatchScreen(type) && (
                <span style={style.text}>Search to Apply</span>
              )
            )}
          </div>
        )
      )}
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
      {isLoading && <Loader />}
      <Alert
        open={openAlert}
        onClose={toggleAlert}
        onSubmit={markAppointmentHandler}
      />
      <SuccessfullyBookedModal
        open={successModal}
        onClose={toggleSuccessModal}
        email={appointedEmail}
        position={appointedPosition}
      />
      <ForcePushAppointmentApplication
        open={forcePushModal}
        onClose={toggleForcePushModal}
        application={selectedApplication}
        toast={toast}
        refreshList={refreshList}
      />
    </Box>
  );
}

export default ApplyAppointment;
